import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import classNames from "classnames"
import "normalize.css"
import "yakuhanjp"
import { wrapper, main, green } from "./layout.module.scss"

import { useLocation } from '@reach/router'
import HeaderSimple from "./HeaderSimple";
import FooterSimple from "./FooterSimple";

interface Props {
  className?: string
  links?: React.ReactNode[]
  children: React.ReactNode
  appearance?: "green"
  location?: string
  simple?: boolean;
}

const Layout = (props: Props) => {

  const location = useLocation()
  console.log(location.href)

  const { className, children, appearance } = props
    const classes = classNames(
    wrapper,
    {
      [green]: appearance === "green"
    },
    className
  )
  return (
    <div className={classes}>
      { props.simple ? (<HeaderSimple/>) : <Header />}
        <main className={main}>{children}</main>
      { props.simple ? (<FooterSimple/>) : <Footer />}
    </div>
  )
}

export default Layout
